import { lazy } from "react";
import { AuthGaurd } from "guards/authGuard";
import SignUpUI from "component/authentication/UI/signUpUI";
import AppealForm from "component/appeal-process/appeal-forms/appeal-form/AppealForm";
import SelectTypeForm from "component/appeal-process/appeal-forms/select-type-form/SelectTypeForm";
import ChargingStations from "component/services/services/charging-stations/ChargingStations";
import EarnWithUs from "component/services/services/earn-with-us/earnWithUs";
import NewServices from "component/services/Services";

// ****************************** Assinging imports to local variables *****************************
const Dashboard = lazy(() => import("../component/dashboard/dashboard"));
const DashboardCommercial = lazy(
  () => import("../component/dashboard-commercial/dashboard-commercial")
);
const CreatePcn = lazy(() => import("../component/pcn/newPcn/addPcnForm"));
const MyVehicleComp = lazy(() => import("../component/my-vehicles/MyVehicles"));
const PCN = lazy(() => import("../component/pcn/pcn"));
const Payments = lazy(() => import("../component/payments/payments"));
const AppealProcess = lazy(
  () => import("../component/appeal-process/AppealProcess")
);
const BookANewSession = lazy(
  () => import("../component/find-parking-near-me/book-a-new-session")
);
const BookingHistory = lazy(
  () =>
    import("../component/find-parking-near-me/booking-history/booking-history")
);
const Calender = lazy(() => import("../component/calender/calender"));
const TrafficRules = lazy(
  () => import("../component/traffic-rules/traffic-rules")
);
const PersonalHelp = lazy(
  () => import("../component/personal-help/personal-help")
);
const MyEnquiries = lazy(
  () => import("../component/my-enquiries/my-enquiries")
);
const MyAccount = lazy(() => import("../component/my-account/my-account"));
const Feedback = lazy(() => import("../component/feedback/personal-feedback"));
const Inbox = lazy(() => import("../component/inbox/InboxComp"));
const ManageEmployees = lazy(
  () => import("../component/manage/manage-employees/manage-employees")
);
const ManageCostCentres = lazy(
  () => import("../component/manage/manage-cost-centres/manage-cost-centres")
);
const ManageAdministrator = lazy(
  () => import("../component/manage/manage-administrators/manage-admin")
);
const ParkAnEmployee = lazy(
  () => import("../component/park-an-employee/parkAnEmployee")
);
const AccountActivity = lazy(
  () => import("../component/account-activity/account-activity")
);
//System Admin Imports
const DashboardSystemAdmin = lazy(
  () => import("../component/systemAdmin-dashboard/dashboard")
);
const ManageUsers = lazy(
  () => import("../component/manage-systemAdmin/users/users")
);
const ManageNewUsers = lazy(
  () => import("../component/manage-systemAdmin/new-users/new-users")
);
const ThirdPartyUsers = lazy(
  () =>
    import(
      "../component/manage-systemAdmin/third-party-users/third-party-users"
    )
);
const SystemPerformance = lazy(
  () => import("../component/system-performance/SystemPerformance")
);
const ApiInventory = lazy(
  () => import("../component/api-inventory/api-inventory")
);
const Newsletter = lazy(() => import("../component/newsletter/newsletter"));
const AuditLogs = lazy(() => import("../component/audit-logs/AuditLog"));
const ThirdPartyLicenses = lazy(
  () => import("component/third-party-licenses/third-party-licenses")
);
const Ratings = lazy(() => import("../component/ratings/systemadmin-feedback"));
const ItHelpDesk = lazy(() => import("../component/it-help-desk/ItHelpDesk"));

//Third Party imports
const ThirdPartyAdmin = lazy(
  () => import("../component/thirdParty-dashboard/dashboad")
);
const NewRequests = lazy(() => import("../component/pending-request/requests"));
const PendingRequests = lazy(
  () => import("../component/pending-request/requests")
);
const CompletedRequests = lazy(
  () => import("../component/pending-request/requests")
);
const CancelledRequests = lazy(
  () => import("../component/pending-request/requests")
);

//lawyers imports
const LawyersDashboard = lazy(
  () => import("../component/lawyers-dashboard/dashboard")
);
const MyClients = lazy(() => import("../component/my-clients/MyClients"));
const FormalChallenge = lazy(
  () => import("../component/formal-challenge-lawyer/formal-challenge-lawyer")
);
const IndependentTribunnals = lazy(
  () => import("../component/independent-tribunnals/independ-tribunals")
);

// ********************************************************************** *************************************** *******************************************

export const routes = [
  {
    path: "/",
    element: (
      <AuthGaurd allowedRoles={["Personal", "Employee"]}>
        <Dashboard />
      </AuthGaurd>
    ),
  },
  {
    path: "/c-dashboard",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <DashboardCommercial />
      </AuthGaurd>
    ),
  },
  {
    path: "/my-vehicles",
    element: (
      <AuthGaurd allowedRoles={["Personal", "Employee"]}>
        <MyVehicleComp />
      </AuthGaurd>
    ),
  },
  {
    path: "/pcn",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <PCN />
      </AuthGaurd>
    ),
  },
  {
    path: "/pcn/createPcn",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <CreatePcn />
      </AuthGaurd>
    ),
  },
  {
    path: "/payments",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <Payments />
      </AuthGaurd>
    ),
  },
  {
    path: "/payments/wallet",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <Payments />
      </AuthGaurd>
    ),
  },
  {
    path: "/payments/card",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <Payments />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeal-process",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <AppealProcess />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeal-process/informal",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <AppealForm />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeal-process/formal",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <AppealForm />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeal-process/independent-adjudicator",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <AppealForm />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeal-process/select-type",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <SelectTypeForm />
      </AuthGaurd>
    ),
  },
  {
    path: "/find",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <BookANewSession />
      </AuthGaurd>
    ),
  },
  {
    path: "/find/book-a-new-session",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <BookANewSession />
      </AuthGaurd>
    ),
  },
  {
    path: "/find/booking-history",
    element: (
      <AuthGaurd
        allowedRoles={["Personal", "Employee", "Corporate", "Commercial"]}
      >
        <BookingHistory />
      </AuthGaurd>
    ),
  },
  {
    path: "/calender",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <Calender />
      </AuthGaurd>
    ),
  },
  {
    path: "/personal-services",
    element: (
      <AuthGaurd allowedRoles={["Personal", "Corporate", "Commercial"]}>
        <NewServices />
      </AuthGaurd>
    ),
  },
  {
    path: "/personal-services/charging-stations",
    element: (
      <AuthGaurd allowedRoles={["Personal", "Corporate", "Commercial"]}>
        <ChargingStations />
      </AuthGaurd>
    ),
  },
  {
    path: "/personal-services/earn-with-us",
    element: (
      <AuthGaurd allowedRoles={["Personal", "Corporate", "Commercial"]}>
        <EarnWithUs />
      </AuthGaurd>
    ),
  },
  {
    path: "/traffic-rules",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Admin",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <TrafficRules />
      </AuthGaurd>
    ),
  },
  {
    path: "/help",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Admin",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <PersonalHelp />
      </AuthGaurd>
    ),
  },
  {
    path: "/my-enquiries",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <MyEnquiries />
      </AuthGaurd>
    ),
  },
  {
    path: "/setting",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Admin",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <MyAccount />
      </AuthGaurd>
    ),
  },
  {
    path: "/feedback",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <Feedback />
      </AuthGaurd>
    ),
  },
  {
    path: "/inbox",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Personal",
          "Employee",
          "Corporate",
          "Commercial",
          "Admin",
          "Lawyers",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <Inbox />
      </AuthGaurd>
    ),
  },
  {
    path: "/manage",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <ManageEmployees />
      </AuthGaurd>
    ),
  },
  {
    path: "/manage/manage-employees",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <ManageEmployees />
      </AuthGaurd>
    ),
  },

  {
    path: "/manage/manage-vehicles",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <MyVehicleComp />
      </AuthGaurd>
    ),
  },
  {
    path: "/manage/manage-cost-centres",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <ManageCostCentres />
      </AuthGaurd>
    ),
  },
  {
    path: "/manage/manage-administrators",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <ManageAdministrator />
      </AuthGaurd>
    ),
  },
  {
    path: "/park-an-employee",
    element: (
      <AuthGaurd allowedRoles={["Corporate"]}>
        <ParkAnEmployee />
      </AuthGaurd>
    ),
  },
  {
    path: "/park-a-customer",
    element: (
      <AuthGaurd allowedRoles={["Commercial"]}>
        <ParkAnEmployee />
      </AuthGaurd>
    ),
  },
  {
    path: "/account-activity",
    element: (
      <AuthGaurd allowedRoles={["Corporate", "Commercial"]}>
        <AccountActivity />
      </AuthGaurd>
    ),
  },

  // system Admin Routes
  {
    path: "/system-admin-dashboard",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <DashboardSystemAdmin />
      </AuthGaurd>
    ),
  },
  {
    path: "/system-performance/cpu-usage",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <SystemPerformance />
      </AuthGaurd>
    ),
  },
  {
    path: "/system-performance/memory-usage",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <SystemPerformance />
      </AuthGaurd>
    ),
  },
  {
    path: "/admin",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ManageUsers />
      </AuthGaurd>
    ),
  },
  {
    path: "/admin/manage-users",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ManageUsers />
      </AuthGaurd>
    ),
  },
  {
    path: "/admin/manage-newUsers",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ManageNewUsers />
      </AuthGaurd>
    ),
  },
  {
    path: "/admin/manage-third-party-users",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ThirdPartyUsers />
      </AuthGaurd>
    ),
  },
  {
    path: "/api-inventory",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ApiInventory />
      </AuthGaurd>
    ),
  },
  {
    path: "/third-party-licenses",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ThirdPartyLicenses />
      </AuthGaurd>
    ),
  },
  {
    path: "/system-performance",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <SystemPerformance />
      </AuthGaurd>
    ),
  },
  {
    path: "/newsletter",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <Newsletter />
      </AuthGaurd>
    ),
  },
  {
    path: "/audit-logs",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <AuditLogs />
      </AuthGaurd>
    ),
  },
  {
    path: "/ratings",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Admin",
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <Ratings />
      </AuthGaurd>
    ),
  },
  {
    path: "/it-help-desk",
    element: (
      <AuthGaurd allowedRoles={["Admin"]}>
        <ItHelpDesk />
      </AuthGaurd>
    ),
  },

  //Third Party Routes
  {
    path: "/third-party-dashboard",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <ThirdPartyAdmin />
      </AuthGaurd>
    ),
  },
  {
    path: "/new-requests",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <NewRequests />
      </AuthGaurd>
    ),
  },
  {
    path: "/pending-requests",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <PendingRequests />
      </AuthGaurd>
    ),
  },
  {
    path: "/completed-requests",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <CompletedRequests />
      </AuthGaurd>
    ),
  },
  {
    path: "/cancelled-requests",
    element: (
      <AuthGaurd
        allowedRoles={[
          "Insurance Companies",
          "MOT Centres",
          "Motor Dealers",
          "Motor Auctioneers",
          "Salvage Dealers",
          "Finance Companies",
          "Fleet Operators",
          "Car Buying Services",
        ]}
      >
        <CancelledRequests />
      </AuthGaurd>
    ),
  },

  //Lawyers Routes
  {
    path: "/lawyers-dashboard",
    element: (
      <AuthGaurd allowedRoles={["Lawyers"]}>
        <LawyersDashboard />
      </AuthGaurd>
    ),
  },
  {
    path: "/my-clients",
    element: (
      <AuthGaurd allowedRoles={["Lawyers"]}>
        <MyClients />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeals",
    element: (
      <AuthGaurd allowedRoles={["Lawyers"]}>
        <FormalChallenge />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeals/formal-challenge",
    element: (
      <AuthGaurd allowedRoles={["Lawyers"]}>
        <FormalChallenge />
      </AuthGaurd>
    ),
  },
  {
    path: "/appeals/independent-tribunals",
    element: (
      <AuthGaurd allowedRoles={["Lawyers"]}>
        <IndependentTribunnals />
      </AuthGaurd>
    ),
  },
  //Sign up routes
  {
    path: "/signup-users",
    element: <SignUpUI />,
  },
];
